import "./AboutHero.css";
import heroImage from "../../assets/manufacture_image.webp";
import { Link } from "react-router-dom";

const AboutHero = () => {
  return (
    <section className="about-hero">
      <div className="content-padding">
        <div className="about-hero-layout">
          <div className="about-hero-copy">
            <p className="about-hero-eyebrow">Made with care</p>

            <h2>Brewed for the moments that matter.</h2>

            <p className="about-hero-text">
              Soft, comfortable, beer-inspired apparel made for slow weekends,
              good pints and the small things worth showing up for.
            </p>

            <div className="about-hero-actions">
              <Link to="/shop" className="about-hero-btn primary">
                Explore the shop
              </Link>

              <Link to="/about" className="about-hero-btn secondary">
                Learn our story
              </Link>
            </div>
          </div>

          <div className="about-hero-media">
            <img
              src={heroImage}
              alt="Solo Pints embroidery manufacturing process"
              className="about-hero-image"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;
